<template>
  <nuxt-link
    :to="{ path: `/blog/${slug}` }"
    class="container is-flex is-align-items-center"
  >
    <div class="">
      <figure class="image is-4by3">
        <!-- Decorative: the article title sits next to it as the link
             text, so repeating it here would double up for screen readers. -->
        <img
          :src="thumbnail"
          :srcset="thumbnailSrcset"
          sizes="(min-width: 769px) 300px, 92vw"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </figure>
    </div>
    <div class="title is-5 pl-4">
      {{ article.title }}
    </div>
  </nuxt-link>
</template>

<script>
import { ghostImageSrcset, ghostImageUrl } from '@/helpers/ghost-image'

export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    article: [],
  }),
  async fetch() {
    try {
      this.article = await this.$axios.$get(`/api/blog/v1/post/${this.slug}`)
    } catch (e) {
      console.log('ee', e)
    }
  },
  computed: {
    thumbnail() {
      return ghostImageUrl(this.article.feature_image, 600)
    },
    thumbnailSrcset() {
      return ghostImageSrcset(this.article.feature_image, [300, 600])
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  border-radius: 20px;
  overflow: hidden;
  background: #ededf0;
}
.image {
  min-width: 200px;
}
</style>
